'use strict';

module.exports = {
    MOVE_AFTER_TRANSFER_VERSION: '3.5.0',
    AWS_S3_TRANSFERS_VERSION: '4.1.0',
    GCS_TRANSFERS_VERSION: '5.0.0',
    DELETE_AFTER_TRANSFER_VERSION: '3.5.0',
    FILE_BASED_TRANSFERS_VERSION: '3.3.0',
    DISCOVER_WALK_MODE_FOLDER_MONITORS_VERSION: '4.1.2',
    FLIGHT_GATEWAY_FOR_S3_TRANSFERS_VERSION: '4.2.0',
    RELAY_SUPPORT_VERSION: '4.3.0',
    PULL_TRANSFERS_SUPPORT_VERSION: '4.4.0',
    BANDWIDTH_MANAGEMENT_VERSION: '4.4.0',
    MEDIA_ENGINE_INDEXING_VERSION: '5.0.0',
    WASABI_OBJECT_STORAGE_TRANSFERS_VERSION: '5.0.0',
    TLS_CONFIG_VERSION: '5.1.0',
    GROWING_OBJECTS_TRANSFERS_VERSION: '5.4.0',
    AZURE_BLOB_STORAGE_TRANSFERS_VERSION: '5.3.3',
    MEDIA_ENGINE_PROXY_EXTRACTION_VERSION: '5.4.0'
};